import { Card, Typography, Box, useTheme } from '@mui/material'
import useCustomStyles from '../../../hooks/CustomStylesHook'

const styles = (theme: any) => ({
  card: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.primary.light,
    borderRadius: '20px',
  },
  section: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  label: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.body2.fontSize,
  },
  valueBox: {
    marginTop: theme.spacing(1),
    padding: theme.spacing(1.5),
    borderRadius: '12px',
    backgroundColor: '#FFFFFF',
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
  },
})

const PremiumCard = ({
  premiumPiad,
  sumInsured,
}: {
  premiumPiad: number
  sumInsured: number
}) => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  return (
    <Card className={classes?.card} elevation={0}>
      <Box className={classes?.section}>
        <Typography className={classes?.label}>Premium Piad</Typography>
        <div className={classes?.valueBox}>₹{premiumPiad}</div>
      </Box>
      <Box className={classes?.section}>
        <Typography className={classes?.label}>Sum Insured</Typography>
        <div className={classes?.valueBox}>₹{sumInsured}</div>
      </Box>
    </Card>
  )
}

export default PremiumCard
